<!-- 维保同期对比 -->
<template>
  <div class="maintenance-period">
    <div class="period-header">
      <div class="header-title">{{ title }}</div>
      <div class="header-controls">
        <div 
          class="period-selector"
          :class="{ active: selectedPeriod === 'month' }"
          @click="selectPeriod('month')"
        >
          {{ $t('月度') }}
        </div>
        <div 
          class="period-selector"
          :class="{ active: selectedPeriod === 'quarter' }"
          @click="selectPeriod('quarter')"
        >
          {{ $t('季度') }}
        </div>
      </div>
    </div>
    
    <div class="chart-container">
      <div ref="chartRef" class="chart"></div>
    </div>
    
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  props: {
    dataContainer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      title: this.$t('保养同期对比'),
      url: {
        LargeScreenTwoYearsIncreaseInspection: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTwoYearsIncreaseInspection"
      },
      chart: null,
      selectedPeriod: 'month',
      thisYearTotal: 0,
      lastYearTotal: 0,
      growthRate: 0
    }
  },
  mounted() {
    this.init()
    this.setupContainerRefresh()
    this.$nextTick(() => {
      this.init()
    })
  },
  beforeDestroy() {
    this.cleanupContainerRefresh()
    this.disposeChart()
  },
  methods: {
    init() {
      this.getData()
    },
    getData() {
      postAction(this.url.LargeScreenTwoYearsIncreaseInspection, { 
        planType: this.selectedPeriod === 'month' ? 3 : 4 
      }).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption(data)
          this.calculateStats(data)
        } else {
          this.loadMockData()
        }
      }).catch(() => {
        this.loadMockData()
      })
    },
    selectPeriod(period) {
      this.selectedPeriod = period
      this.getData()
    },
    calculateStats(data) {
      this.thisYearTotal = data.reduce((sum, item) => sum + (item.thisYearNum || 0), 0)
      this.lastYearTotal = data.reduce((sum, item) => sum + (item.lastYearNum || 0), 0)
      
      if (this.lastYearTotal > 0) {
        this.growthRate = ((this.thisYearTotal - this.lastYearTotal) / this.lastYearTotal * 100).toFixed(1)
      } else {
        this.growthRate = 0
      }
    },
    loadMockData() {
      const mockData = [
        { time: '1月', lastYearNum: 18, thisYearNum: 22 },
        { time: '2月', lastYearNum: 20, thisYearNum: 25 },
        { time: '3月', lastYearNum: 22, thisYearNum: 28 },
        { time: '4月', lastYearNum: 25, thisYearNum: 30 },
        { time: '5月', lastYearNum: 28, thisYearNum: 32 },
        { time: '6月', lastYearNum: 30, thisYearNum: 35 }
      ]
      this.setOption(mockData)
      this.calculateStats(mockData)
    },
    setOption(data) {
      const y1 = data.map(item => item.lastYearNum || 0)
      const y2 = data.map(item => item.thisYearNum || 0)
      const xData = data.map(item => item.time || '')
      
      const option = {
        color: ['#50E3C2', '#F6BB2F'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('去年'), this.$t('今年')],
          textStyle: {
            color: '#CEE2FF'
          },
          itemHeight: 10,
          right: 0,
          top: 10
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xData,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671'],
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('单位:次'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
        ],
        series: [
          {
            name: this.$t('去年'),
            type: 'line',
            symbol: 'circle',
            animationDelay: 1000,
            stack: 'Total',
            animationDuration: 300,
            data: y1
          },
          {
            name: this.$t('今年'),
            type: 'line',
            symbol: 'circle',
            animationDelay: 1000,
            stack: 'Total',
            animationDuration: 300,
            data: y2
          }
        ]
      }
      
      this.initChart(option)
    },
    initChart(option) {
      this.disposeChart()
      
      if (!this.$refs.chartRef) return
      
      this.chart = echarts.init(this.$refs.chartRef)
      this.chart.setOption(option)
      
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
        window.removeEventListener('resize', this.handleResize)
      }
    },
    setupContainerRefresh() {
      if (this.dataContainer && this.dataContainer.onRefresh) {
        this.dataContainer.onRefresh = this.refreshData
      }
    },
    cleanupContainerRefresh() {
      if (this.dataContainer && this.dataContainer.onRefresh) {
        this.dataContainer.onRefresh = null
      }
    },
    refreshData() {
      this.getData()
    },
    formatNumber(num) {
      return num.toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
.maintenance-period {
  height: 100%;
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.period-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  color: #b6deff;
  font-size: 16px;
  font-weight: 500;
}

.header-controls {
  display: flex;
  gap: 2px;
  background: rgba(0, 48, 111, 0.4);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 16px;
  padding: 2px;
  font-size: 11px;
}

.period-selector {
  padding: 2px 6px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 11px;
  color: #8BA6C6;
  
  &.active {
    background: linear-gradient(135deg, #00E4FF, #00FF88);
    color: #fff;
    box-shadow: 0 2px 8px rgba(0, 228, 255, 0.3);
  }
  
  &:hover:not(.active) {
    color: #b6deff;
    background: rgba(0, 170, 255, 0.1);
  }
}

.chart-container {
  flex: 1;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  padding: 10px;
}

.chart {
  width: 100%;
  height: 100%;
}

.period-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.stat-card {
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
    border-color: rgba(0, 170, 255, 0.5);
    box-shadow: 0 4px 12px rgba(0, 170, 255, 0.15);
  }
}

.stat-label {
  color: #a8c6f3;
  font-size: 12px;
  margin-bottom: 8px;
}

.stat-value {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
  margin-bottom: 5px;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  
  &.trend-up {
    color: #52c41a;
  }
  
  &.trend-down {
    color: #ff4d4f;
  }
}

.stat-comparison {
  color: #8BA6C6;
  font-size: 12px;
}

@media (max-width: 1600px) {
  .maintenance-period {
    padding: 10px;
    gap: 10px;
  }
  
  .period-stats {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .stat-card {
    padding: 12px;
  }
  
  .stat-value {
    font-size: 20px;
  }
}

@media (max-width: 1200px) {
  .period-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .header-controls {
    width: 100%;
    justify-content: center;
  }
  
  .stat-card {
    padding: 10px;
  }
  
  .stat-value {
    font-size: 18px;
  }
}
</style>